const Images = {
  aloe: require('./images/aloe.jpg'),
  greenhill_mobile: require('./images/greenhill_mobile.jpg'),
  rayavadee: require('./images/rayavadee.jpg'),
};

export default Images;
